import React from "react";
import { Button, Icon } from "@culturehq/components";

import { useProfile } from "app/context";
import { ProfileLink } from "app/links";
import { canViewSurveyResults } from "app/permissions";
import { Trans } from "app/utils";
import SurveyLink from "app/links/SurveyLink";

import QuickOptions from "components/display/QuickOptions";
import SurveyAvailable from "components/survey/SurveyAvailable";
import SurveyCompleted from "components/survey/SurveyCompleted";
import PinUserActivityToggle from "components/feed/feed-item/PinUserActivityToggle";

import FeedItemTitle from "./FeedItemTitle";

const WidgetSurveyActivated = ({ item, onSurveyComplete, onUserActivityUpdate }) => {
  const { profile } = useProfile();
  const survey = item.entity;

  return (
    <>
      <FeedItemTitle item={item} date={item.bumpedAt}>
        <QuickOptions>
          <ul className="dropdown-menu">
            <li>
              <SurveyLink survey={survey}>
                <Icon icon="eye" />
                <Trans>View this survey</Trans>
              </SurveyLink>
            </li>
            {profile.organizationAdmin && (
              <li>
                <PinUserActivityToggle
                  userActivity={item}
                  onUserActivityUpdate={onUserActivityUpdate}
                />
              </li>
            )}
          </ul>
        </QuickOptions>
        <h3 className="FeedItem__title">
          <ProfileLink user={item.users[0]} />
          {" "}
          <Trans>created a new survey: </Trans>
          <strong>{survey.title}</strong>
        </h3>
      </FeedItemTitle>
      <div className="FeedItem__preview__widget_survey_activated">
        {item.entity.statusForUser !== "complete" && (
          <SurveyAvailable
            survey={survey}
            onSurveyComplete={onSurveyComplete}
          />
        )}

        {canViewSurveyResults(profile, survey) && (
          <>
            {" "}
            <SurveyCompleted survey={survey}>
              {onTrigger => (
                <Button icon="stats-bars" inverted onClick={onTrigger}>
                  <Trans>Results</Trans>
                </Button>
              )}
            </SurveyCompleted>
          </>
        )}
      </div>
    </>
  );
};

export default WidgetSurveyActivated;
